<template>
  <ServiceVendorInviteDetail />
</template>

<script setup>
import ServiceVendorInviteDetail from '@/views/frontend/ServiceVendorInviteDetail.vue'
</script>
